import { Page } from '@/components';
import { useParams } from 'react-router';
import { useNetwork } from '@/hooks';
import CollateralBuyersTable from './CollateralBuyersTable';
import HistoricCollateralBought from './HistoricCollateralBoughtGraphs';

export default function BuyersPage() {
  const network = useNetwork() as string;
  const { marketAddress } = useParams() as { marketAddress: string };

  return (
    <Page title="Collateral Buyers">
      <HistoricCollateralBought marketAddress={marketAddress} />
      <CollateralBuyersTable marketAddress={marketAddress} network={network} />
    </Page>
  );
}
